import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import CacheKeys from '../../../cache/CacheKeys.js';
import CacheManager from '../../../cache/CacheManager.js';
import DaysPastDuePageUI from './DaysPastDuePageUI.js';

class DaysPastDuePageSF extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorList: null,
      daysPastDueList: null,
      downloadMode: false,
      downloadConsumerMode: false,
      response: null,
    };
  }

  render() {
    return (
      <DaysPastDuePageUI
        context={this.props.context}
        errorList={this.state.errorList}
        daysPastDueList={this.state.daysPastDueList}
        //
        downloadMode={this.state.downloadMode}
        onDownloadClick={() => { this.setState({ downloadMode: true }) }}
        onDownloadCancel={() => { this.setState({ downloadMode: false }) }}
        //
        downloadConsumerMode={this.state.downloadConsumerMode}
        onDownloadConsumerClick={() => { this.setState({ downloadConsumerMode: true }) }}
        onDownloadConsumerCancel={() => { this.setState({ downloadConsumerMode: false }) }}
        response={this.state.response}
        onRefreshClick={this.onRefreshClick}
      />
    );
  }

  componentDidMount() {
    let context = this.props.context;
    this.getDaysPastDues(context);
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.year == prevProps.match.params.year && this.props.match.params.month == prevProps.match.params.month)
      return
    this.getDaysPastDues(this.props.context)
  }

  getDaysPastDues(context) {
    let year = this.props.match.params.year
    let month = this.props.match.params.month
    const cacheKey = this.props.match.params.year && this.props.match.params.month
      ? CacheKeys.DaysPastDues(this.props.match.params.year, this.props.match.params.month)
      : CacheKeys.DaysPastDues();
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/loans/dpd`,
      cacheKey: cacheKey,
      callback: this.getDaysPastDuesCallback,
      ttlInSecs: 600,
    });
    if (!this.props.match.params.year || !this.props.match.params.month)
      cacheManager.getObject2(context, {}, {})
    else
      cacheManager.getObject2(context, {}, {
        year: this.props.match.params.year,
        month: this.props.match.params.month,
      })
  }

  getDaysPastDuesCallback = (response) => {
    this.setState({
      daysPastDueList: response.daysPastDueList,
      response: response
    });
  };

  onRefreshClick = (noBusy) => {
    let context = this.props.context;
    CacheManager.removeObject(CacheKeys.DaysPastDues(this.props.match.params.year, this.props.match.params.month));
    if (noBusy === 'noBusy') {
      this.getDaysPastDues(context);
    } else {
      this.setState({ daysPastDueList: null, errorList: null }, () =>
        this.getDaysPastDues(context)
      );
    }
  };
}

export default withRouter(DaysPastDuePageSF);
